import 'babel-polyfill';
import UUID from 'uuid-js';
import moment from 'moment';

import ElementCategories from './constants/element-categories';

/**
 * @function appendCacheBuster
 * Append a cache-busting string to a request endpoint
 */
export function appendCacheBuster (endpoint) {
	return `${endpoint}?_=${new Date().getTime()}`;
}

/**
 * @function coalesce
 * check an object for the specified property, and return the property if found
 * if it is not found, return a fallback
 * @param  {object} object
 * object to check
 * @param  {string} property
 * property to check for
 * @param  {Boolean} [fallback=false]
 * fallback value
 */
export function coalesce (object, property, fallback = false) {
	return object.hasOwnProperty(property) ? object[property] : fallback;
}

/**
 * @function getPublicElementSpec
 * @param  {string} type
 * Element type
 * @return {object}
 */
export function getPublicElementSpec (type) {
	let template;

	ElementCategories.forEach(category => {
		let spec = category.publicElementSpecification;

		Object.keys(spec).find(key => {
			if (spec[key].type === type) {
				template = spec[key];
			}
		});
	});

	return template;
}

/**
 * @function getURLParameter
 * Get the value of the specified parameter
 */
export function getURLParameter(name) {
	let regex = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)');
	return decodeURIComponent((regex.exec(location.search) || [,""])[1].replace(/\+/g, '%20')) || null;
}

/**
 * @function getUtcString
 * @param  {number} value
 */
export function getUtcString (value) {
	return value ? moment.utc(value).valueOf() : moment({hour: 0}).utc().valueOf();
}

/**
 * @function getUniqueId
 * Generate an RFC-compliant UUID
 * @param {string} prefix
 * identifier for the type of element being given an id.
 * ex. "fieldset," "row," or "element"
 */
export function getUniqueId(prefix) {
	return `${prefix}_${UUID.create(4).toString()}`;
}

/**
 * @function isTouchCapable
 * check if the user's device support touch events
 * @return {Boolean}
 */
export function isTouchCapable() {
	return (
		window.hasOwnProperty('ontouchstart')
		|| window.DocumentTouch && document instanceof window.DocumentTouch
		|| navigator.maxTouchPoints > 0
		|| window.navigator.msMaxTouchPoints > 0
	);
}

/**
 * @function formatValueToLocale
 * formats a string representing a numerical value 
 * or a number to use appropiate comma separators
 * @param {string|number} value
 * @return {string}
 */
export function formatValueToLocale(value) {
	if (value === undefined) {
		return;
	}
	return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 }); // use default host formatting and always display decimals
}


// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/utilities.js